import { type FormQueries, defFormQueries } from '@kizen/query/form';
import AxiosService from '__services/AxiosService';

const queries: FormQueries = defFormQueries(AxiosService);

export const formQuery: FormQueries['formQuery'] = queries.formQuery;

export const formsQuery: FormQueries['formsQuery'] = queries.formsQuery;

export const surveyQuery: FormQueries['surveyQuery'] = queries.surveyQuery;

export const surveysQuery: FormQueries['surveysQuery'] = queries.surveysQuery;
